import React, { useEffect, useState, useContext } from "react";
import { GlobalContext } from "../context/GlobalContext";
import axios from "axios";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { ImCross } from "react-icons/im";
import { RiFileExcel2Fill } from "react-icons/ri";
import DataTable, { createTheme } from "react-data-table-component";
import kategori from "../kategori.json";
import GenerateExcel from "./GenerateExcel";
import { CSVLink } from "react-csv";

const AllProductTable = () => {
  let num = 1;
  let navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [arrHeader, setArrHeader] = useState([]);
  const { contextState, contextFunctions } = useContext(GlobalContext);
  const { inputProduct, fetchStatus, setFetchStatus } = contextState;
  const [arrProduct, setArrProduct] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [search, setSearch] = useState("");
  const [columns, setColumns] = useState();

  createTheme("solarized", {
    text: {
      primary: "#000000",
      secondary: "#000000",
    },
    background: {
      default: "#9e9e9e",
    },
  });

  const handleSearch = (event) => {
    setSearch(event.target.value);
  };

  const handleKategori = (event) => {
    setSelectedCategory(event.target.value);
  };

  const resetKategori = () => {
    setSelectedCategory("");
  };

  const renderFieldName = (str) => {
    var i,
      frags = str.split("_");
    for (i = 0; i < frags.length; i++) {
      frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
    }
    return frags.join(" ");
  };

  const handleChange = (row) => {
    navigate(`/products/${row._id}`);
    setFetchStatus(true);
  };

  const getTimeStamp = () => {
    const locale = "id-ID";
    const months = [
      "Januari",
      "Februari",
      "Maret",
      "April",
      "Mei",
      "Juni",
      "Juli",
      "Augustus",
      "September",
      "October",
      "November",
      "December",
    ];
    const d = new Date();
    const date = d.getDate();
    const month = d.getMonth();
    const hour = d.getHours();
    const minute = d.getMinutes();
    return `DataProduk${renderText(selectedCategory)}_${date} ${
      months[month]
    }_${hour}.${minute}`;
  };

  const renderText = (str) => {
    return str.replace(/(^\w|\s\w)/g, (m) => m.toUpperCase());
  };

  const renderTextArr = (str) => {
    const renderHeader = [];
    str.map((el) => {
      renderHeader.push(el.replace(/(^\w|\s\w)/g, (m) => m.toUpperCase()));
    });
    return renderHeader;
  };

  useEffect(() => {
    setLoading(true);
    (async () => {
      const arrField = await axios.get(
        `https://productspec.cyclic.app/form_field/`
      );
      const newArrayField = [
        "_id",
        ...Object.keys(inputProduct),
        ...arrField.data.map((field) => field.field),
      ];

      const setConfig = () => {
        if (Cookies.get("token") === undefined) {
          return null;
        } else return Cookies.get("token");
      };
      const config = {
        headers: { "x-access-token": setConfig() },
      };

      const objProduct = await axios.get(
        "https://productspec.cyclic.app/product",
        config
      );

      const result = objProduct.data.map((product) => {
        const productProperties = Object.keys(product).filter((key) =>
          newArrayField.includes(key)
        );
        return productProperties.reduce((obj, key) => {
          obj[key] = product[key];
          return obj;
        }, {});
      });
      if (selectedCategory === "") {
        setArrProduct(
          result.filter((product) =>
            Object.values(product).some((val) =>
              val.toLowerCase().includes(search.toLowerCase())
            )
          )
        );
      } else {
        const tempRes = result.filter((product) =>
          Object.values(product).some((val) =>
            val.toLowerCase().includes(search.toLowerCase())
          )
        );
        setArrProduct(
          tempRes.filter((el) => el.jenis_produk == selectedCategory)
        );
      }

      const tempColumns = await Object.keys(result[0]).map((key) => {
        return {
          name: renderFieldName(key),
          selector: key,
          sortable: true,
        };
      });
      setColumns(tempColumns);
      setArrHeader(newArrayField);
      setLoading(false);
    })();
  }, [search, selectedCategory]);

  // if (loading) {
  //   return <p className="loading"></p>;
  // }

  return (
    <div className="">
      <div className="search-bar-container">
        <div className="dropdown ">
          <button
            className="btn btn-secondary dropdown-toggle dropdown-category"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {selectedCategory === ""
              ? "Lihat berdasarkan kategori"
              : `${renderText(selectedCategory)}`}
          </button>
          <ul className="dropdown-menu">
            {selectedCategory !== "" && (
              <li>
                <button
                  onClick={resetKategori}
                  type="button"
                  className="btn fw-bold dropdown-item"
                >
                  Reset Kategori
                </button>
              </li>
            )}
            {kategori.map((el) => (
              <li>
                <button
                  className="dropdown-item"
                  onClick={handleKategori}
                  value={el}
                  type="button"
                >
                  {renderText(el)}
                </button>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <input
            type="search"
            className="search-bar"
            placeholder="Cari produk..."
            value={search}
            onChange={handleSearch}
          />
          {search !== "" && (
            <button
              type="button"
              className="reset-search-btn"
              onClick={() => setSearch("")}
            >
              <ImCross />
            </button>
          )}
        </div>
      </div>

      <div className="table-data table-product" id="table-data">
        {loading ? (
          <p className="">Sedang mengambil data...</p>
        ) : (
          <DataTable
            className="dataTables_wrapper"
            columns={columns}
            data={arrProduct}
            fixedHeader
            fixedHeaderScrollHeight="300px"
            highlightOnHover
            pagination
            responsive
            striped
            pointerOnHover
            theme="solarized"
            onRowClicked={handleChange}
          />
        )}

        {/* <GenerateExcel header={arrHeader} productData={arrProduct} /> */}
      </div>
      <div className="container-export">
        {loading ? null : (
          <CSVLink
            data={arrProduct}
            headers={arrHeader}
            filename={`${getTimeStamp()}.csv`}
            className="icon-export"
          >
            <span className="text-btn-export">
              <RiFileExcel2Fill />
            </span>
            Export
          </CSVLink>
        )}
      </div>
    </div>
  );
};

export default AllProductTable;
